import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";

import { roles, services,users } from "../../policies/actions";
import policySelectors from "../../policies/selectors";
import SearchBox from "../../shared/components/SearchBox";

class ListViewFilter extends Component {
  constructor(props) {
    super(props);
    const { filterTerm } = props;
    this.state = { value: filterTerm };
  }

  componentDidUpdate(prevProps) {
    const { selected } = this.props;
    if (prevProps.selected !== selected) {
      this.resetFilter();
    }
  }

  handleChange = e => {
    const {
      selected,
      setEntitiesFilterTerm,
      setRolesFilterTerm,
      setServicesFilterTerm
    } = this.props;
    const filterTerm = e.target.value.toLowerCase();

    this.setState({ value: e.target.value });

    switch (selected) {
      case "service":
        setServicesFilterTerm(filterTerm);
        break;
      case "role":
        setRolesFilterTerm(filterTerm);
        break;
      default:
        setEntitiesFilterTerm(filterTerm);
    }
  };

  resetFilter = () => {
    const {
      setEntitiesFilterTerm,
      setRolesFilterTerm,
      setServicesFilterTerm
    } = this.props;

    this.setState({ value: "" });
    setEntitiesFilterTerm("");
    setRolesFilterTerm("");
    setServicesFilterTerm("");
  };

  render() {
    const { value } = this.state;
    const { selected } = this.props;

    return (
      <SearchBox
        value={value}
        placeholder={`Filter by ${
          selected === "entity" ? "group/user" : selected
        }`}
        onChange={e => this.handleChange(e)}
        onReset={() => this.resetFilter()}
      />
    );
  }
}

ListViewFilter.defaultProps = {
  filterTerm: ""
};

ListViewFilter.propTypes = {
  selected: PropTypes.oneOf(["entity", "service", "role"]).isRequired,
  setEntitiesFilterTerm: PropTypes.func.isRequired,
  setRolesFilterTerm: PropTypes.func.isRequired,
  setServicesFilterTerm: PropTypes.func.isRequired,
  filterTerm: PropTypes.string
};

const mapStateToProps = (state, ownProps) => {
  const { selected } = ownProps;
  switch (selected) {
    case "service":
      return { filterTerm: policySelectors.services.getFilterTerm(state) };
    case "role":
      return { filterTerm: policySelectors.roles.getFilterTerm(state) };
    default:
      return { filterTerm: policySelectors.users.getFilterTerm(state) };
  }
};

const mapDispatchToProps = {
  setEntitiesFilterTerm: users.setFilterTerm,
  setRolesFilterTerm: roles.setFilterTerm,
  setServicesFilterTerm: services.setFilterTerm
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListViewFilter);
